export default "__VITE_ASSET__Cf$SQ4eE__"